/**
 * Created by Denis Kuzin on 01 september 2025
 */

const CharacterUnlockedWindow = CleverappsWindow.extend({
    ctor: function (quest) {
        this.quest = quest;
        this.personConfig = {
            role: quest.unit.code,
            emotion: "happy"
        };

        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            name: "CharacterUnlockedWindow",
            content: this.createContent(),
            noBackground: true,
            openSound: bundles.characterunlocked.urls.window_open_effect,
            styles: {
                decors: cleverapps.styles.CharacterUnlockedWindow.decors,
                windowShowUpAnimation: undefined
            }
        });
    },

    createContent: function () {
        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(cleverapps.styles.CharacterUnlockedWindow.size);

        const title = this.title = this.createTitle();
        const details = this.details = this.createDetails();
        const field = this.field = this.createField();
        const person = this.person = this.createPerson();

        details.setCascadeOpacityEnabledRecursively(true);

        content.addChild(title);
        content.addChild(details);
        content.addChild(field);
        content.addChild(person);

        return content;
    },

    createTitle: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.title;

        const title = cleverapps.UI.generateOnlyText(Messages.get("CharacterUnlockedWindow.title"), cleverapps.styles.FONTS.CHARACTERUNLOCKED_TITLE_TEXT);
        title.setAlignment(styles.position);

        return title;
    },

    createDetails: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.details;

        const descriptionText = this.descriptionText = cleverapps.UI.generateOnlyText(Messages.get(`Units.${this.quest.unit.code}.describe`), cleverapps.styles.FONTS.WHITE_TEXT);
        descriptionText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        descriptionText.setDimensions(styles.description[cleverapps.resolution.mode].width, 0);
        descriptionText.fitTo(undefined, styles.description[cleverapps.resolution.mode].height);

        const rewardsContainer = this.createRewardsSection();

        const detailsLayout = new cleverapps.Layout([descriptionText, rewardsContainer], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin[cleverapps.resolution.mode]
        });
        detailsLayout.setAnchorPoint(0.5, 0.5);
        detailsLayout.setAlignment(styles.position);

        return detailsLayout;
    },

    createField: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.field;

        const field = new cleverapps.Spine(bundles.characterunlocked.jsons.field);
        field.setAlignment(styles.position);
        field.setLocalZOrder(1);
        field.setVisible(false);

        return field;
    },

    createRewardsSection: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.rewards;

        const rewardsTitle = this.rewardsTitle = this.createRewardTitle();
        const rewardsList = this.rewardsList = new RewardsListComponent(this.quest.rewards, {
            font: cleverapps.styles.FONTS.CHARACTERUNLOCKED_REWARD_TEXT,
            margin: styles.list.margin,
            shine: true,
            event: cleverapps.EVENTS.EARN.OTHER
        });

        return new cleverapps.Layout([rewardsTitle, rewardsList], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.container.margin
        });
    },

    createRewardTitle: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.rewards;

        const text = cleverapps.UI.generateOnlyText(Messages.get("CharacterUnlockedWindow.rewards"), cleverapps.styles.FONTS.CHARACTERUNLOCKED_REWARD_TEXT);
        const leftLine = new cc.Sprite(bundles.characterunlocked.frames.sideline);
        const rightLine = new cc.Sprite(bundles.characterunlocked.frames.sideline);
        leftLine.setScaleX(-1);

        return new cleverapps.Layout([leftLine, text, rightLine], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.title.margin
        });
    },

    createPerson: function () {
        const styles = cleverapps.styles.CharacterUnlockedWindow.character;

        const container = new cc.Node();
        container.setAlignment(styles.position);
        container.setContentSize2(styles);
        container.setAnchorPoint(0.5, 0);

        if (cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL) {
            const person = new Person(this.personConfig);
            person.setAnchorPoint(0.5, 0);
            person.setScale2(styles.scale);

            const rays = new cleverapps.Spine(bundles.characterunlocked.jsons.rays);
            rays.setAnimation(0, "animation", true);
            rays.setAlignment(styles.rays);
            rays.setLocalZOrder(-1);
            person.addChild(rays);

            const ribbon = this.ribon = cleverapps.UI.createScale9Sprite(bundles.characterunlocked.frames.ribbon, cleverapps.UI.Scale9Rect.TwoPixelXY);
            ribbon.setContentSize(Math.max(styles.ribbon.width, person.width * person.getScaleX()), styles.ribbon.height);
            ribbon.setAlignment(styles.ribbon);
            ribbon.setLocalZOrder(1);
            container.addChild(ribbon);
            ribbon.setCascadeOpacityEnabledRecursively(true);

            const name = cleverapps.UI.generateOnlyText(cleverapps.unitsLibrary.getUnitName(this.quest.unit), cleverapps.styles.FONTS.LEVELUPWINDOW_TITLE_TEXT);
            name.setAlignment(styles.ribbon.text);
            name.fitTo(ribbon.width - styles.ribbon.paddingX * 2, 0);
            ribbon.addChild(name);

            const personAnchorBone = person.getBone("person_anchor");
            if (personAnchorBone) {
                const dX = (personAnchorBone.x || 0) * resolutionScale * person.getScaleX();
                person.setAlignment(ribbon.x - dX, ribbon.y + (styles.ribbon.personDy || 0));
            } else {
                person.setAlignment(container.width / 2, 0);
            }

            container.addChild(person);
        }

        return container;
    },

    addUnitsCrossFormation: function (field, stage, onlyHero) {
        const styles = cleverapps.styles.CharacterUnlockedWindow.field;
        const cellWidth = styles.cell.width;
        const cellHeight = styles.cell.height;

        let crossPositions = [
            { x: 1, y: 1 },
            { x: 0, y: 1 },
            { x: 2, y: 1 },
            { x: 1, y: 0 },
            { x: 1, y: 2 }
        ];

        if (onlyHero) {
            crossPositions = [
                { x: 1, y: 1 }
            ];
        }

        const units = [];

        crossPositions.forEach((position) => {
            const container = new cc.Node();
            container.setAnchorPoint(0.5, 0.5);
            container.setScale(2);
            container.setVisible(false);

            const x = position.x + position.y + 1;
            const y = position.x - position.y;

            if (!onlyHero) {
                const view = new cleverapps.Spine(bundles.highlight_animations.jsons.highlight_json);
                view.setSkin("tile_light_1");
                view.setAnimation(0, "yellow", true);
                container.addChild(view);
            }

            const unitView = UnitView.getUnitImage({
                code: this.quest.unit.code,
                stage
            }, {
                alignAnchorX: true,
                alignAnchorY: true
            });
            container.addChild(unitView);

            container.setAlignment(
                x * cellWidth / 2 + styles.offsetX,
                y * cellHeight / 2 + styles.offsetY
            );

            container.setLocalZOrder(1000 - y);

            field.addChild(container);

            units.push(container);
        });

        return units;
    },

    moveUnitsToCenter: function (units, isFinalMerge, callback) {
        const styles = cleverapps.styles.CharacterUnlockedWindow.field;

        if (!units || units.length === 0) {
            callback && callback();
            return;
        }

        const cellWidth = styles.cell.width;

        const centerX = 3 * cellWidth / 2 + styles.offsetX;
        const centerY = styles.offsetY;

        units.forEach((unit, index) => {
            const isLast = units.length - 1 === index;
            const baseScale = unit.getScale();

            unit.setScale(baseScale * 0.5);

            unit.runAction(new cc.Sequence(
                new cc.Show(),
                new cc.ScaleTo(0.1, baseScale * 1.1).easing(cc.easeIn(1)),
                new cc.ScaleTo(0.15, baseScale * 1).easing(cc.easeOut(1)),
                new cc.DelayTime(0.1),
                new cc.MoveTo(0.2, centerX, centerY).easing(cc.easeIn(2)),
                new cc.CallFunc(() => {
                    if (isLast) {
                        if (isFinalMerge) {
                            cleverapps.effects.fire("character.unlock.final");
                        } else {
                            cleverapps.effects.fire("character.unlock.loop");
                        }

                        const mergeAnimation = new cleverapps.Spine(bundles.merge_animations.jsons.merge_animation_json);
                        mergeAnimation.setAlignment(centerX, centerY);
                        mergeAnimation.setScale(baseScale);
                        mergeAnimation.setCompleteListenerRemove();
                        this.field.addChild(mergeAnimation, 1001);
                        mergeAnimation.setAnimation(0, "animation", false);
                    }
                }),
                new cc.Hide(),
                new cc.DelayTime(0.6),
                new cc.CallFunc(() => {
                    if (isLast) {
                        callback();
                    }
                }),
                new cc.RemoveSelf()
            ));
        });
    },

    showFinalHeroAnimation: function (unit) {
        const baseScale = unit.getScale();

        unit.runAction(new cc.Sequence(
            new cc.Show(),
            new cc.ScaleTo(0.1, baseScale * 1.1).easing(cc.easeIn(1)),
            new cc.ScaleTo(0.15, baseScale * 1).easing(cc.easeOut(1)),
            new cc.DelayTime(0.35),
            new cc.ScaleTo(0.17, baseScale * 1.1),
            new cc.ScaleTo(0.3, baseScale * 0.5),
            new cc.RemoveSelf()
        ));
    },

    onShow: function () {
        this._super();

        if (this.ribon) {
            this.ribon.setOpacity(0);
            this.ribon.setScale(0);
            this.ribon.runAction(new cc.Spawn(
                new cc.FadeIn(0.6),
                new cc.ScaleTo(0.6, 1).easing(cc.easeBackOut())
            ));
        }

        const basePersonScale = this.person.getScale();
        this.person.setScale(0);
        this.person.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.ScaleTo(0.5, basePersonScale).easing(cc.easeBackOut())
        ));

        this.title.setOpacity(0);
        this.title.setScale(0);
        this.title.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.Spawn(
                new cc.FadeIn(0.6),
                new cc.ScaleTo(0.6, 1).easing(cc.easeBackOut())
            )
        ));

        const pos = this.descriptionText.getPosition();
        this.descriptionText.setPositionY(pos.y + cleverapps.styles.CharacterUnlockedWindow.details.offsetY);
        this.descriptionText.setOpacity(0);
        this.descriptionText.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.Spawn(
                new cc.FadeIn(0.3),
                new cc.MoveTo(0.2, pos).easing(cc.easeOut(1))
            )
        ));

        this.rewardsTitle.setOpacity(0);
        this.rewardsTitle.setScale(0);
        this.rewardsTitle.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.Spawn(
                new cc.FadeIn(0.6),
                new cc.ScaleTo(0.6, 1).easing(cc.easeBackOut())
            )
        ));

        const actions = [];

        this.rewardsList.targets.forEach((target, id) => {
            if (target.shine) {
                target.shine.setVisible(false);
            }

            target.setCascadeOpacityEnabledRecursively(true);
            target.setScale(0);

            const targetAction = new cc.Sequence(
                new cc.DelayTime(0.6 + id * 0.2),
                new cc.CallFunc(() => {
                    if (target.shine) {
                        target.shine.setVisible(true);
                        target.shine.setAnimationAndIdleAfter("open", "idle");
                    }
                }),
                new cc.ScaleTo(0.3, 1).easing(cc.easeBackOut())
            );

            actions.push(new cc.CallFunc(() => {
                target.runAction(targetAction);
            }));
        });

        this.runAction(new cc.Spawn(actions));
    },

    playCloseAnimation: function () {
        if (this.tapToContinue) {
            this.tapToContinue.runAction(new cc.Sequence(
                new cc.FadeOut(0.3),
                new cc.Hide()
            ));
        }

        this.player = new ActionPlayer([
            function (f) {
                this.rewardsList.receiveRewardsAnimation({
                    callback: f
                });
            }.bind(this),

            function (f) {
                if (this.tapToContinue) {
                    this.tapToContinue.stopAllActions();
                    this.tapToContinue.runAction(new cc.Sequence(
                        new cc.Show(),
                        new cc.FadeIn(0.3)
                    ));
                }

                this.details.runAction(new cc.Sequence(
                    new cc.FadeOut(0.3),
                    new cc.Hide(),
                    new cc.CallFunc(f)
                ));
            }.bind(this),

            function (f) {
                this.field.setAnimationAndIdleAfter("showup", "idle");
                this.field.setVisible(true);
                this.field.runAction(new cc.Sequence(
                    new cc.DelayTime(0.3),
                    new cc.CallFunc(f)
                ));

                if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                    this.person.setVisible(false);
                }
            }.bind(this),

            function (f) {
                let currentStage = 0;

                const processNextStage = () => {
                    if (currentStage >= this.quest.unit.stage) {
                        const units = this.addUnitsCrossFormation(this.field, currentStage, true);
                        this.showFinalHeroAnimation(units[0]);
                        f();
                        return;
                    }

                    const units = this.addUnitsCrossFormation(this.field, currentStage, false);
                    const isFinalMerge = currentStage === this.quest.unit.stage - 1;
                    this.moveUnitsToCenter(units, isFinalMerge, () => {
                        currentStage++;
                        processNextStage();
                    });
                };

                processNextStage();
            }.bind(this),

            function (f) {
                setTimeout(f, 600);
            },

            function (f) {
                this.field.setAnimation(0, "hide", false);
                this.field.setCompleteListener(f);
            }.bind(this)
        ]);

        this.player.play(() => {
            this.close();
        });
    },

    close: function () {
        if (!this.player) {
            this.playCloseAnimation();
            return;
        }

        if (this.player) {
            this.player.stop();
        }

        this._super();
    },

    listBundles: function () {
        const bundles = ["characterunlocked"];
        const personObject = cleverapps.persons.getRole(this.personConfig.role);

        if (personObject && personObject.bundle) {
            bundles.push(personObject.bundle);
        }

        return bundles;
    }
});

CharacterUnlockedWindow.IsNeeded = function (quest) {
    if (!quest || !quest.unit || quest.type !== Map2d.SPAWN) {
        return false;
    }

    const family = Families[quest.unit.code];
    return family && family.type === "hero" && UnitsLibrary.LastStage(quest.unit.code).stage === quest.unit.stage;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CHARACTERUNLOCKED_TITLE_TEXT: {
        size: 100,
        color: cleverapps.styles.COLORS.YELLOW,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CHARACTERUNLOCKED_REWARD_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.Decorators, {
    "bunting_left": {
        lovesWindow: true,
        type: Decors.TYPE_ANIMATION,
        json: bundles.characterunlocked.jsons.decor,
        animation: "animation",
        idle: "idle",
        zOrder: -1,
        position: [
            { x: { align: "left", dx: -700 }, y: { align: "top", dy: 210 } },
            { x: { align: "left", dx: -350 }, y: { align: "top", dy: 210 } },
            { x: { align: "left", dx: -200 }, y: { align: "top", dy: 210 } }
        ]
    },

    "bunting_right": {
        lovesWindow: true,
        type: Decors.TYPE_ANIMATION,
        json: bundles.characterunlocked.jsons.decor,
        animation: "animation",
        idle: "idle",
        zOrder: -1,
        position: [
            { x: { align: "right", dx: 700 }, y: { align: "top", dy: 210 } },
            { x: { align: "right", dx: 350 }, y: { align: "top", dy: 210 } },
            { x: { align: "right", dx: 200 }, y: { align: "top", dy: 210 } }
        ],
        scale: {
            x: -1,
            y: 1
        }
    }
});

cleverapps.styles.CharacterUnlockedWindow = {
    size: [
        { width: 1000, height: 1500 },
        { width: 2400, height: 1000 },
        { width: 2400, height: 1000 }
    ],

    title: {
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: 0 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: 50 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: 50 } }
        ]
    },

    details: {
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "center", dy: 100 } },
            { x: { align: "center", dx: 600 }, y: { align: "center", dy: -170 } },
            { x: { align: "center", dx: 600 }, y: { align: "center", dy: -170 } }
        ],
        margin: [150, 70, 70],
        description: [
            { width: 900, height: 300 },
            { width: 1150, height: 300 },
            { width: 1150, height: 300 }
        ],
        offsetY: -30
    },

    rewards: {
        container: { margin: 50 },
        title: { margin: 15 },
        list: { margin: { x: 150 } }
    },

    character: {
        width: 500,
        height: 800,

        position: [
            { x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -300 } },
            { x: { align: "left", dx: 230 }, y: { align: "bottom", dy: -400 } },
            { x: { align: "left", dx: 230 }, y: { align: "bottom", dy: -400 } }
        ],
        scale: [0.63, 1, 1],
        rays: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 100 }
        },
        ribbon: {
            text: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            },

            width: 535,
            height: 254,
            paddingX: 40,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 130 }
        },
        offset: 240
    },

    field: {
        position: [
            { x: { align: "center", dx: 20 }, y: { align: "center", dy: -100 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: -100 } },
            { x: { align: "center", dx: 400 }, y: { align: "center", dy: -100 } }
        ],

        cell: {
            width: 346,
            height: 200
        },

        offsetX: 0,
        offsetY: 470
    },

    decors: {
        "bunting_left": true,
        "bunting_right": true
    }
};
